export const textArtName = String.raw`
                                                                                        {   } 
                                                                                       }_{ __{ 
                                                                                    .-{   }   }-.
                                                                                   (   }     {   )
                                                                                   |\`-.._____..-'| 
        _               _                _____ _          _                        |             ;--.
      | |             | |              / ____| |        | |                        |            (__  \
      | | ___  _ __ __| | __ _ _ __   | (___ | |__   ___| |__   __ _ _ __   ___    |             | )  )
  _   | |/ _ \| '__/ _  |/ _ '| '_ \  '\___ \| '_ \ / _ | '_ \ / _' | '_ \ / _ \   |             |/  /
'| |__| | (_) | | | (_| | (_| | | | |  ____) | | | |  __| | | | (_| | | | |  __/   |             /  / 
  \____/ \___/|_|  \__,_|\__,_|_| |_| |_____/|_| |_|\___|_| |_|\__,_|_| |_|\___|   |            (  /
                                                                                   \`-.._____..-'
`;
export const projectsOuputText = String.raw`
    - Conways game of life    https://github.com/0neMiss/GameOfLife
    - A simple LSP server     https://github.com/0neMiss/learning_lsp
    - How Many Rhode Islands? https://howmanyrhodeislands.netlify.app/
    - Trendy Personal Site    https://jordanshehanetrendyportfolio.netlify.app/
  `;

export const linksOutputText = String.raw`
      - Github   https://github.com/0neMiss?tab=overview
      - linkedin https://www.linkedin.com/in/jordan-shehane-b2807a196/
    `;
export const contactOutputText = String.raw`
    If you want to contact me the best way is to send me a message on linkedin!

    - email     jordanshehane@gmail.com
    - phone     618-946-4327
    - linkedin  https://www.linkedin.com/in/jordan-shehane-b2807a196/
    `;
export const helpOutputText =
  "other commands:\n - projects       Provides a list of links to other things I've worked on.\n - contact        How to contact me!\n - links          Links to things like my linkedin and github";
